export const STORAGE_KEY = {
  DIRECTION: 'DIRECTION',
  CURRENT_LANGUAGE: 'CURRENT_LANGUAGE',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  EXPIRES_IN: 'EXPIRES_IN',
  IS_LOGIN: 'IS_LOGIN',
};
